import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

const InviteMembersSuccessModal = ({ isOpen }) => {
  const { t, ready } = useTranslation(['members', 'global']);
  if (!ready) return null;
  return (
    <Modal
      style={{ maxWidth: '600px', minWidth: '600px' }}
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      centered
    >
      <ModalHeader className="justify-content-center mb--4">
        <h2> {t('members:inviteMembersSuccessModalHeading')} </h2>
      </ModalHeader>
      <ModalBody>
        <p>{t('members:inviteMembersSuccessModalDescription')}</p>
        <p>{t('members:inviteMembersSuccessModalDescription2')}</p>

        <div className="d-flex justify-content-center mt-4">
          <Button
            color="primary"
            className={` d-block `}
            style={{
              border: '1px solid black',
              borderRadius: '30px',
            }}
            onClick={() => {
              window.location.reload();
            }}
          >
            {t('global:refresh')}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default InviteMembersSuccessModal;
